// production settings
module.exports = {
    API_URL: 'https://app.fiifi-dev.com/api',
    LI_API_KEY: '771cwtypivbnff',
    LI_REDIRECT: 'https://app.fiifi-dev.com/linkedin-auth.html',
    URL: 'app.fiifi-dev.com',
    LI_SCOPE: 'r_emailaddress r_liteprofile',
    LI_STATE: 'some-string',
    LI_SEC: '9V0J8vhAdjZ7H3N1',
    API_PWD: '1O2qHvxGKwjKvsAPZNpQ',
    API_SALT: 'Imbl9npwpS8wh9nzAolx',
    cred: {
        "aws_project_region": "us-east-1",
        "aws_cognito_identity_pool_id": "us-east-1:d24df6a6-e78f-44f0-a8ee-a3f2549dda21",
        "aws_cognito_region": "us-east-1",
        "aws_user_pools_id": "us-east-1_4q921VFYf",
        "aws_user_pools_web_client_id": "34f583hk8ga06ppura3rb7u105",
        mandatorySignIn: true,
        "oauth": {
            domain: "fiifi.auth.us-east-2.amazoncognito.com",
            scopes: ['email', 'profile', 'aws.cognito.signin.user.admin', 'openid'],
            redirectSignIn: "http://localhost:8080/#/dashboard/overview",
            redirectSignOut: "http://localhost:8080/#/login",
            responseType: 'code',
            options: {
                AdvancedSecurityDataCollectionFlag: false
            }
        }
    },
    ACTIVATE_PRO_LINK: "https://fiifi.co/pricing/",
    CONTACT_US_LINK: 'https://fiifi.co/fiifi-contact-us/',
    STRIPE_KEY: "pk_test_H4slTE8TzhaResbLqMzqNMmz00HEFZOtsh",
    ap: {
        'monthly': 'price_1GxE8SC86VOLEvv5kC0bYtX3',
        'yearly': 'price_1GxE8TC86VOLEvv5OTZQIVw2',
        'plan': '5ef05c02ab204c1770220646',
        'storage': 5120
    },
    pi: {
        'monthly': 'price_1Gx7BzC86VOLEvv5fZVcJU1L',
        'yearly': 'price_1GxE8TC86VOLEvv5OTZQIVw2',
        'plan': '5ef05c02ab204c1770220645',
        'storage': 10240
    },
    ROLE: {
        '5f55dc56b2c7431cd8941512': {
            label: 'Owner',
            description: 'The owner of the account and all workspaces.'
        },
        '5f55dc56b2c7431cd8941514': {
            label: 'Manager',
            description: 'This user has all access to the workspace and is very active in the workspace but does not have admin and owner privileges. This is probably the most active user of the product.'
        },
        '5f55dc56b2c7431cd8941513': {
            label: 'Admin',
            description: 'The admin for an individual workspace, the admin has all access, edit, and view rights for a single workspace. An admin can be invited to multiple workspaces and has to be invited individually.'
        },
        '5f55dc56b2c7431cd8941515': {
            label: 'Collaborator',
            description: 'A collaborator has the ability to work within the workspace and a regular user. They are like an associate who reports to a manager. Most of their activities will be updated to the notification center and sent to the Manager Owner and Admin.'
        }
    },
    CRUNCHBASE_IMAGE_URL: "https://res.cloudinary.com/crunchbase-production/image/upload",
    EMAIL_FORWARDING_DOMAIN: "noreply.fiifi-dev.com",
    DEAL_ROOM_EMAILS: ["founders@fiifi.co", "gandhar@gytworkz.com"],
    ENVIRONMENT: 'DEVLOPMENT',
    SHARED_PORTFOLIO_URL: "https://app.fiifi-dev.com/co",
}